module.exports = {
  feeAppVersionCode: '1.0.0',
  product: 4,
  email: 'feeboard@ideaboard.xyz',
  companyUrl: 'www.ideaboard.xyz',
  toastMessages: {
    networkError: "Network Error, please try again later!",
    thankYouResponse: "Thank you for your interest, we will get back to you soon!",
  },
  copyRight: "© 2021, IdeaBoard. All rights reserved.",
  playStoreUrl: "https://play.google.com/store/apps/details?id=com.ideaboard&referrer",
  landingUrl: '/',
  api: {
    url: `https://api.${process.env.REACT_APP_DOMAIN}`,
    responseType: 'json',
    ws_url: `wss://api.${process.env.REACT_APP_DOMAIN}/cable`,
    timeout: 20000,
    withCredentials: true
  },
  cookie: {
    secure: true,
    subDomain: `fee.${process.env.REACT_APP_DOMAIN}`,
    domainRegex: `.${process.env.REACT_APP_DOMAIN}`,
    accountsDomain: `accounts.${process.env.REACT_APP_DOMAIN}`,
    homeDomain: `fee.${process.env.REACT_APP_DOMAIN}`,
    qbank: `qbank.${process.env.REACT_APP_DOMAIN}`
  }
}

